import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "item"]
  static values = {
    reorderUrl: String,
    folderId: Number,
    errorMessage: String
  }

  connect() {
    this.draggedItem = null
    this.initialOrder = ""
    this.isPersisting = false
  }

  dragStart(event) {
    const item = event.currentTarget

    if (!item || this.isPersisting) {
      event.preventDefault()
      return
    }

    this.draggedItem = item
    this.initialOrder = this.currentOrderSignature()

    item.classList.add("is-dragging")
    this.listTarget.classList.add("is-sorting")

    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move"
      event.dataTransfer.setData("text/plain", item.dataset.mediaSortId || "")
    }
  }

  dragOver(event) {
    if (!this.draggedItem || this.isPersisting) return

    event.preventDefault()

    const targetItem = event.target.closest("[data-media-sort-target='item']")
    if (!targetItem || targetItem === this.draggedItem) return

    const targetRect = targetItem.getBoundingClientRect()
    const insertBefore = event.clientY < (targetRect.top + targetRect.height / 2)

    this.listTarget.insertBefore(this.draggedItem, insertBefore ? targetItem : targetItem.nextSibling)
  }

  drop(event) {
    if (!this.draggedItem) return

    event.preventDefault()
  }

  async dragEnd() {
    if (!this.draggedItem) return

    this.draggedItem.classList.remove("is-dragging")
    this.listTarget.classList.remove("is-sorting")
    this.draggedItem = null

    if (this.isPersisting) return
    if (this.currentOrderSignature() === this.initialOrder) return

    await this.persistOrder()
  }

  currentOrderSignature() {
    return this.currentMediaFileIds().join(",")
  }

  currentMediaFileIds() {
    return this.itemTargets.map((item) => Number(item.dataset.mediaSortId)).filter((id) => Number.isInteger(id) && id > 0)
  }

  async persistOrder() {
    if (!this.hasReorderUrlValue || !this.hasFolderIdValue) return

    this.isPersisting = true
    this.listTarget.classList.add("is-saving")

    try {
      const response = await fetch(this.reorderUrlValue, {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken()
        },
        body: JSON.stringify({
          media_files: {
            folder_id: this.folderIdValue,
            media_file_ids: this.currentMediaFileIds()
          }
        })
      })

      if (response.ok) return

      const payload = await response.json().catch(() => ({}))
      this.showError(payload.error)
    } catch (_error) {
      this.showError()
    } finally {
      this.isPersisting = false
      this.listTarget.classList.remove("is-saving")
    }
  }

  csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
  }

  showError(message = null) {
    window.alert(message || this.errorMessageValue || "Sortierung konnte nicht gespeichert werden.")
  }
}
